export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="w-full h-[400px] rounded-lg overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/0f6e8649e242f1d61124a200a8e34ec6.jpg"
              alt="About ACBuy Spreadsheet 2026"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <span className="inline-block px-3 py-1 bg-amber-100 text-amber-700 text-xs font-semibold rounded-full uppercase tracking-wider mb-4">About ACBuy Spreadsheet</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>
              The #1 ACBuy Spreadsheet 2026 Database
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              The <strong>ACBuy Spreadsheet 2026</strong> is the most comprehensive community-curated database for replica shoppers. Unlike the hipobuy spreadsheet, we update daily with 100,000+ verified product listings, QC photos, and trusted seller links.
            </p>
            <p className="text-gray-600 text-sm leading-relaxed mb-6">
              Whether you're searching for the best hipobuy spreadsheet 2026 alternative, looking for hipobuy shipping coupons, planning a hipobuy haul, or using the hipobuy QC finder — our platform covers everything you need to shop smarter and save more.
            </p>
            <ul className="space-y-3 mb-8">
              {[
                "100,000+ verified product listings updated daily",
                "Full QC photo integration — better than hipobuy sheets",
                "Hipobuy shipping coupon tracker & deals",
                "Community-rated sellers with honest reviews",
                "Free to use — no registration required",
              ].map((item) => (
                <li key={item} className="flex items-start gap-2 text-sm text-gray-700">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                    <i className="ri-checkbox-circle-fill text-amber-500"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
            <a
              href="https://repsw2c.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-amber-500 hover:bg-amber-600 text-white font-semibold rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              Browse ACBuy Spreadsheet <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
